// src/pages/SubscriptionsPage.js
import React, { useState, useEffect, useMemo } from "react";
import { Container, Table, Button, Card, Modal, Form } from "react-bootstrap";

import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

import AddSubscription from "./AddSubscription";
import EditSubscription from "./EditSubscription";

const SubscriptionsPage = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [subscriptions, setSubscriptions] = useState([]);
    const [selectedSubscription, setSelectedSubscription] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [editSubscription, setEditSubscription] = useState(null);

    const filteredSubscription = useMemo(() => {
        return subscriptions.filter((subscription) => {
            return subscription.sub_name && subscription.sub_name.toLowerCase().includes(searchTerm.toLowerCase());
        });
    }, [subscriptions, searchTerm]);

    // Handlers
    const handleView = (pk_sub_key, index) => {
        const subscription = subscriptions.find((sub) => sub.pk_sub_key === pk_sub_key);
        setSelectedSubscription(subscription);
        setShowViewModal(true);
        setSelectedIndex(Number(index) + 1);
    };

    const handleCloseAddModal = () => {
        setShowAddModal(false);
    };
    const handleCloseEditModal = () => {
        setShowEditModal(false);
    };
    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setSelectedIndex(null);
    };

    useEffect(() => {
        fetchAllSubscription();
    }, []);

    const fetchAllSubscription = async () => {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "getAllSubscription",
        });

        const output = response.data;

        if (output.length > 0) {
            setSubscriptions(output);
        }
    };

    const handleEdit = async (subscription) => {
        setEditSubscription(subscription);
        setShowEditModal(true);
    };

    const handleDelete = async (sub_key) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it",
            });

            if (result.isConfirmed) {
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "deleteSubscription",
                    pk_sub_key: sub_key,
                });

                const output = response.data;

                if (output) {
                    await Swal.fire("Deleted!", "The Subscription has been successfully removed.", "success");
                    fetchAllSubscription();
                }
            }
        } catch (error) {
            // Handle any errors here
            console.error("An error occurred: ", error);
        }
    };

    return (
        <Container className="mt-4">
            <ToastContainer position="top-center" />
            <div className="border-0">
                <div className="d-flex justify-content-between align-items-center admin-page-head">
                    <h4 className="border-0">Subscriptions Management</h4>
                    <Button variant="dark" onClick={() => setShowAddModal(true)} className="mb-3">
                        Add Subscription
                    </Button>
                </div>

                <div className="mb-4">
                    <Form>
                        <div className="row">
                            <div className="col-md-4">
                                <Form.Group>
                                    <Form.Control type="text" placeholder="Search by name" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                                </Form.Group>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className="bg-light border-0">
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered table-responsive-scroll">
                            <thead className="thead-dark">
                                <tr>
                                    <th>ID</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Amount</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(filteredSubscription) &&
                                    filteredSubscription.map((subscription, index) => (
                                        <tr key={subscription.pk_sub_key}>
                                            <td>{index + 1}</td>
                                            <td>{subscription.sub_name}</td>
                                            <td>{subscription.sub_status === 1 ? "Active" : "In-active"}</td>
                                            <td>{"$" + subscription.sub_amount}</td>
                                            <td>
                                                <Button
                                                    variant="outline-dark"
                                                    onClick={() => handleEdit(subscription)}
                                                    className="me-2"
                                                    data-bs-toggle="tooltip"
                                                    title="Edit"
                                                >
                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                </Button>
                                                <Button
                                                    variant="outline-danger"
                                                    onClick={() => handleDelete(subscription.pk_sub_key)}
                                                    className="me-2"
                                                    data-bs-toggle="tooltip"
                                                    title="Delete"
                                                >
                                                    <i className="fa-solid fa-trash"></i>
                                                </Button>
                                                <Button
                                                    variant="outline-info"
                                                    onClick={() => handleView(subscription.pk_sub_key)}
                                                    data-bs-toggle="tooltip"
                                                    title="View"
                                                >
                                                    <i className="fa-solid fa-eye"></i>
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <AddSubscription showModal={showAddModal} handleClose={handleCloseAddModal} fetchAllSubscription={fetchAllSubscription} />
                <EditSubscription
                    showModal={showEditModal}
                    handleClose={handleCloseEditModal}
                    fetchAllSubscription={fetchAllSubscription}
                    subscription={editSubscription}
                />
            </div>

            {/* View Modal */}
            {selectedSubscription && (
                <Modal show={showViewModal} onHide={handleCloseViewModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Subscription Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>
                            <strong>Name:</strong> {selectedSubscription.sub_name}
                        </p>
                        <p>
                            <strong>Status:</strong> {selectedSubscription.sub_status === 1 ? "Active" : "In-active"}
                        </p>
                        <p>
                            <strong>Month:</strong> {selectedSubscription.sub_month}
                        </p>
                        <p>
                            <strong>Amount:</strong> {"$" + selectedSubscription.sub_amount}
                        </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseViewModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </Container>
    );
};

export default SubscriptionsPage;
